<script setup lang="ts">
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';
    import { Trash2 } from 'lucide-vue-next';
    import { useViewOptionsStore } from '@/stores/view-options';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';

    const viewOptionsStore = useViewOptionsStore();

    const { t } = useI18n();

    interface Props {
        viewOptionId: number;
        disabled?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        disabled: false,
    });

    const mutation = useMutation({
        mutationFn: async () => {
            return await axios.delete(
                route('v2.dashboard.view-options.destroy', props.viewOptionId),
            );
        },
        onSuccess: () => {
            viewOptionsStore.deleteViewOption(props.viewOptionId);
        },
    });
</script>

<template>
    <AlertDialog>
        <AlertDialogTrigger as-child>
            <Button
                variant="delete"
                size="icon_sm"
                :disabled="disabled"
            >
                <Trash2 />
            </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('forms.delete_confirmation.header') }}</AlertDialogTitle>
                <AlertDialogDescription>{{
                    t('forms.delete_confirmation.description')
                }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('forms.delete_confirmation.cancel') }}</AlertDialogCancel>
                <AlertDialogAction @click="mutation.mutate()">{{
                    t('forms.delete_confirmation.continue')
                }}</AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
